// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2voND","left":"styles_left__2rnyq"};